<template>
  <UikitListItem
    class="osk-products-filters-item-categories"
    no-padding
    @click="handleClick"
  >
    <span>
      {{ item.name }}
    </span>

    <UikitLabel
      v-if="label"
      :text="label"
      class="osk-products-filters-item-categories__label"
      small
      bold
    />

    <UikitIcon
      v-if="item.hasMoreValues"
      name="ArrowRightMark"
      class="osk-products-filters-item-categories__arrow"
    />
  </UikitListItem>
</template>

<script setup lang="ts">
import { CategoryTreeFilter } from '~/restAPI/data-contracts';

const props = defineProps<{
  item: CategoryTreeFilter
}>();

const emits = defineEmits<{
  (e: 'openFilter', value: CategoryTreeFilter): void,
}>();

const selected = computed(() => props.item.selectedValues ?? []);

const label = computed(() => {
  if (selected.value?.length > 1) return selected.value.length;
  if (selected.value?.length === 1) return selected.value[0].value;
  return '';
});

function handleClick() {
  if (!props.item.hasMoreValues) return;
  emits('openFilter', props.item);
}
</script>

<style scoped lang="scss">
@import "~/assets/scss/settings/index";

.osk-products-filters-item-categories {
  display: flex;
  align-items: center;
  height: 52px;
  padding: 0 16px !important;

  &__label {
    margin-left: auto;

    & + .osk-products-filters-item-categories__arrow {
      margin-left: $indent-compact;
    }
  }

  &__arrow {
    margin-left: auto;
    margin-right: -5px;
  }
}
</style>
